var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.704 1.994c1.812 0 3.454.713 4.643 1.87a6.23 6.23 0 0 1 1.907 4.476c.077 3.455-2.215 7.348-6.625 11.771-4.322-3.62-6.533-7.517-6.475-11.755a6.24 6.24 0 0 1 1.908-4.492 6.634 6.634 0 0 1 4.642-1.87z",
    stroke: "#F6B119",
    strokeWidth: 2.307,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69 6.526c1.472 0 2.944 1.32 2.944 2.947a2.946 2.946 0 1 1-5.889 0c0-1.628 1.472-2.947 2.945-2.947z",
    fill: "#F6B119"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOrange);
export default __webpack_public_path__ + "static/media/locationOrange.dc351198a132220947061cca507d0584.svg";
export { ForwardRef as ReactComponent };